"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionCard = void 0;
var _Icon = require("../../../../../UI/Icon");
var _SectionCard = _interopRequireDefault(require("./SectionCard.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SectionCard = function SectionCard(props) {
  var iconName = props.iconName,
    title = props.title,
    children = props.children;
  var styles = (0, _SectionCard.default)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TaskManager__section-card'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-TaskManager__section-card__icon'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        name: iconName,
        width: 24,
        height: 24
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-TaskManager__section-card__title'],
        children: title
      }), children]
    })]
  });
};
exports.SectionCard = SectionCard;